import type { HorizontalSide, VerticalSide } from '@app-types/styles'
import type { ContentfulImageData } from '@components/contentful-image'
import { ContentfulImage } from '@components/contentful-image'
import { SectionBlock } from '@components/layout/section-block'
import { Skeleton } from '@components/skeleton'
import { sectionImageHeight, sectionImageWidth } from '@styles/variables'
import classNames from 'classnames'
import type { FunctionComponent, ReactNode } from 'react'

import styles from './section-visual.module.scss'

export const SectionVisual: FunctionComponent<SectionVisualProps> = ({
    sideOnSmallScreen,
    sideOnLargeScreen,
    videoNode,
    image,
    preset,
    loading,
    fade,
    verticalCenter = false,
    fullWidth = false,
}) => {
    return (
        <SectionBlock
            className={classNames(styles.visual, { [styles.fade]: fade })}
            justify={verticalCenter ? 'center' : 'space-between'}
            sideOnSmallScreen={sideOnSmallScreen}
            sideOnLargeScreen={sideOnLargeScreen}
        >
            <div>
                {videoNode && (
                    <div className={styles[`box-${preset}`]}>{videoNode}</div>
                )}
            </div>

            {loading ? (
                <Skeleton
                    height={sectionImageHeight}
                    width={sectionImageWidth}
                />
            ) : (
                image && (
                    <ContentfulImage
                        url={image.url}
                        alt={image.alt}
                        contentType={image.contentType}
                        sizes='(max-width: 768px) 100vw, 50vw'
                        priority={preset === 'primary'}
                        data-testid='section.image'
                    />
                )
            )}
        </SectionBlock>
    )
}

export type SectionVisualProps = {
    image?: ContentfulImageData
    loading?: boolean
    videoNode?: ReactNode
    preset?: 'primary' | 'default'
    sideOnLargeScreen?: HorizontalSide
    sideOnSmallScreen?: VerticalSide
    verticalCenter?: boolean
    fade?: boolean
    fullWidth?: boolean
}
